'use strict';

var _classCallCheck = require("/var/lib/jenkins/workspace/Genomica_site_latest/node_modules/@babel/runtime/helpers/classCallCheck");

var _createClass = require("/var/lib/jenkins/workspace/Genomica_site_latest/node_modules/@babel/runtime/helpers/createClass");

var _inherits = require("/var/lib/jenkins/workspace/Genomica_site_latest/node_modules/@babel/runtime/helpers/inherits");

var _possibleConstructorReturn = require("/var/lib/jenkins/workspace/Genomica_site_latest/node_modules/@babel/runtime/helpers/possibleConstructorReturn");

var _getPrototypeOf = require("/var/lib/jenkins/workspace/Genomica_site_latest/node_modules/@babel/runtime/helpers/getPrototypeOf");

var _wrapNativeSuper = require("/var/lib/jenkins/workspace/Genomica_site_latest/node_modules/@babel/runtime/helpers/wrapNativeSuper");

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Date.prototype.toString.call(Reflect.construct(Date, [], function () {})); return true; } catch (e) { return false; } }

var assert = require('assert');

var RedisError = /*#__PURE__*/function (_Error) {
  _inherits(RedisError, _Error);

  var _super = _createSuper(RedisError);

  function RedisError() {
    _classCallCheck(this, RedisError);

    return _super.apply(this, arguments);
  }

  _createClass(RedisError, [{
    key: "name",
    get: function get() {
      return this.constructor.name;
    }
  }]);

  return RedisError;
}( /*#__PURE__*/_wrapNativeSuper(Error));

var ParserError = /*#__PURE__*/function (_RedisError) {
  _inherits(ParserError, _RedisError);

  var _super2 = _createSuper(ParserError);

  function ParserError(message, buffer, offset) {
    var _this;

    _classCallCheck(this, ParserError);

    assert(buffer);
    assert.strictEqual(typeof offset, 'number');
    var tmp = Error.stackTraceLimit;
    Error.stackTraceLimit = 2;
    _this = _super2.call(this, message);
    Error.stackTraceLimit = tmp;
    _this.offset = offset;
    _this.buffer = buffer;
    return _this;
  }

  _createClass(ParserError, [{
    key: "name",
    get: function get() {
      return this.constructor.name;
    }
  }]);

  return ParserError;
}(RedisError);

var ReplyError = /*#__PURE__*/function (_RedisError2) {
  _inherits(ReplyError, _RedisError2);

  var _super3 = _createSuper(ReplyError);

  function ReplyError(message) {
    var _this2;

    _classCallCheck(this, ReplyError);

    var tmp = Error.stackTraceLimit;
    Error.stackTraceLimit = 2;
    _this2 = _super3.call(this, message);
    Error.stackTraceLimit = tmp;
    return _this2;
  }

  _createClass(ReplyError, [{
    key: "name",
    get: function get() {
      return this.constructor.name;
    }
  }]);

  return ReplyError;
}(RedisError);

var AbortError = /*#__PURE__*/function (_RedisError3) {
  _inherits(AbortError, _RedisError3);

  var _super4 = _createSuper(AbortError);

  function AbortError() {
    _classCallCheck(this, AbortError);

    return _super4.apply(this, arguments);
  }

  _createClass(AbortError, [{
    key: "name",
    get: function get() {
      return this.constructor.name;
    }
  }]);

  return AbortError;
}(RedisError);

var InterruptError = /*#__PURE__*/function (_AbortError) {
  _inherits(InterruptError, _AbortError);

  var _super5 = _createSuper(InterruptError);

  function InterruptError() {
    _classCallCheck(this, InterruptError);

    return _super5.apply(this, arguments);
  }

  _createClass(InterruptError, [{
    key: "name",
    get: function get() {
      return this.constructor.name;
    }
  }]);

  return InterruptError;
}(AbortError);

module.exports = {
  RedisError: RedisError,
  ParserError: ParserError,
  ReplyError: ReplyError,
  AbortError: AbortError,
  InterruptError: InterruptError
};